import { Branch, createBranch, convertUnixToDate } from '@golden/gdk-base';
import getUnixTime from 'date-fns/getUnixTime';
import { map } from 'rxjs';
import { ADMIN_API } from '../AdminAPI';
export function createActivityService(api, trunk) {
    return {
        activities: createBranch({
            trunk,
            branch: Branch.ACTIVITY,
            value: [],
            operator: () => api.fetch(ADMIN_API.GET_ACTIVITY_LIST)
        }),
        getActivityManagementList(data) {
            return api.fetch(ADMIN_API.GET_ACTIVITY_MANAGEMENT_LIST, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'start_at', 'end_at', 'show_start_at', 'show_end_at', 'updated_at'))
            })));
        },
        getActivityPriority() {
            return api.fetch(ADMIN_API.GET_ACTIVITY_PRIORITY);
        },
        updateActivityPriority(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_PRIORITY, { data });
        },
        getActivityTagsPriority() {
            return api.fetch(ADMIN_API.GET_ACTIVITY_TAGS_PRIORITY);
        },
        updateActivityTagsPriority(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_TAGS_PRIORITY, { data });
        },
        activateActivity(id, is_active) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_ACTIVE, { data: { is_active }, config: { urlParams: { id } } });
        },
        deteleActivity(id) {
            return api.fetch(ADMIN_API.DEL_ACTIVITY, { config: { urlParams: { id } } });
        },
        getActivityLayout(activity_id) {
            return api.fetch(ADMIN_API.GET_ACTIVITY_LAYOUT, { data: { activity_id } }).pipe(map((res) => ({
                ...convertUnixToDate(res, 'start_at', 'end_at', 'show_start_at', 'show_end_at'),
                setting: (res.setting != null)
                    ? {
                        ...convertUnixToDate(res.setting, 'start_at', 'end_at'),
                        deposit_condition: (res.setting.deposit_condition != null)
                            ? convertUnixToDate(res.setting.deposit_condition, 'start_at', 'end_at')
                            : null,
                        bet_condition: (res.setting.bet_condition != null)
                            ? convertUnixToDate(res.setting.bet_condition, 'start_at', 'end_at')
                            : null,
                        games: (res.setting.games != null)
                            ? res.setting.games.map((game) => convertUnixToDate(game, 'start_at', 'end_at', 'game_start_at', 'bet_start_at', 'bet_end_at'))
                            : null
                    }
                    : null
            })));
        },
        createActivityLayout(data) {
            return api.fetch(ADMIN_API.POST_ACTIVITY_LAYOUT, { data });
        },
        updateActivityLayout(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_LAYOUT, { data });
        },
        getActivityBanner(activity_id) {
            return api.fetch(ADMIN_API.GET_ACTIVITY_BANNER, { data: { activity_id } }).pipe(map((res) => convertUnixToDate(res, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        createActivityBanner(data) {
            return api.fetch(ADMIN_API.POST_ACTIVITY_BANNER, { data });
        },
        updateActivityBanner(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_BANNER, { data });
        },
        // 系統活動
        getActivityLayoutNewMemberBonus() {
            return api.fetch(ADMIN_API.GET_ACTIVITY_NEW_MEMBER_BONUS).pipe(map((res) => convertUnixToDate(res, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        updateActivityLayoutNewMemberBonus(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_NEW_MEMBER_BONUS, { data });
        },
        getActivityLayoutRecommendFriend() {
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECOMMEND_FRIEND).pipe(map((res) => convertUnixToDate(res, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        updateActivityLayoutRecommendFriend(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_RECOMMEND_FRIEND, { data });
        },
        getActivityLayoutDailySignInBonus() {
            return api.fetch(ADMIN_API.GET_ACTIVITY_DAILY_SIGN_IN_BONUS).pipe(map((res) => convertUnixToDate(res, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        updateActivityLayoutDailySignInBonus(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_DAILY_SIGN_IN_BONUS, { data });
        },
        getActivityLayoutFeedbackBonus() {
            return api.fetch(ADMIN_API.GET_ACTIVITY_FEEDBACK_BONUS).pipe(map((res) => convertUnixToDate(res, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        updateActivityLayoutFeedbackBonus(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_FEEDBACK_BONUS, { data });
        },
        getActivityLayoutFeedbackExtraBonus() {
            return api.fetch(ADMIN_API.GET_ACTIVITY_FEEDBACK_EXTRA_BONUS).pipe(map((res) => convertUnixToDate(res, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        updateActivityLayoutFeedbackExtraBonus(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_FEEDBACK_EXTRA_BONUS, { data });
        },
        getActivityLayoutWeeklyBonus() {
            return api.fetch(ADMIN_API.GET_ACTIVITY_WEEKLY_BONUS).pipe(map((res) => convertUnixToDate(res, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        updateActivityLayoutWeeklyBonus(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_WEEKLY_BONUS, { data });
        },
        getActivityLayoutRankBonus() {
            return api.fetch(ADMIN_API.GET_ACTIVITY_RANK_BONUS).pipe(map((res) => convertUnixToDate(res, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        updateActivityLayoutRankBonus(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_RANK_BONUS, { data });
        },
        getActivityLayoutDragonBoatFestival2023() {
            return api.fetch(ADMIN_API.GET_ACTIVITY_DRAGON_BOAT_FESTIVAL_2023).pipe(map((res) => convertUnixToDate(res, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        updateActivityLayoutDragonBoatFestival2023(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_DRAGON_BOAT_FESTIVAL_2023, { data });
        },
        uploadImage(file) {
            const formData = new FormData();
            formData.append('file', file);
            return api.fetch(ADMIN_API.POST_IMAGE, { data: formData });
        },
        getActivityNewMemberBonus(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_NEW_MEMBER_BONUS, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'applied_at', 'updated_at'))
            })));
        },
        getActivityRecordRecommendFriend(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_RECOMMEND_FRIEND, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'applied_at', 'updated_at'))
            })));
        },
        getActivityRecordInviteFriend(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_INVITE_FRIEND, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'updated_at'))
            })));
        },
        getActivityRecordInviteFriendRelations(userAccount) {
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_INVITE_FRIEND_RELATIONS, { config: { urlParams: { userAccount } } });
        },
        getActivityRecordUpgradeBonus(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_UPGRADE_BONUS, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'received_at', 'updated_at'))
            })));
        },
        getActivityRecord7(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_DAILY_SIGN_IN, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'applied_at', 'updated_at'))
            })));
        },
        getActivityRecordWeeklyBonus(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_WEEKLY_BONUS, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'received_at', 'updated_at'))
            })));
        },
        getActivityRecordBirthdayBonus(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_BIRTHDAY_BONUS, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'received_at', 'updated_at'))
            })));
        },
        getActivityRecordNewYear2023(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_NEW_YEAR_2023, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'applied_at', 'updated_at'))
            })));
        },
        getActivityRecordNewYear2024(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_NEW_YEAR_2024, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'applied_at', 'received_at'))
            })));
        },
        getActivityRecordNewYear2025Draw(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_NEW_YEAR_2025_DRAW, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'updated_at'))
            })));
        },
        getActivityRecordNewYear2025DrawTicket(data) {
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_NEW_YEAR_2025_DRAW_TICKET, { data });
        },
        postActivityRecordNewYear2025DrawTicket(data) {
            return api.fetch(ADMIN_API.POST_ACTIVITY_RECORD_NEW_YEAR_2025_DRAW_TICKET, { data });
        },
        getActivityRecordNewYear2025RedEnvelope(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_NEW_YEAR_2025_RED_ENVELOPE, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'updated_at'))
            })));
        },
        getActivityRecordNewYearTicket(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_NEW_YEAR_TICKET, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'updated_at'))
            })));
        },
        postActivityRecordNewYearTicket(data) {
            return api.fetch(ADMIN_API.POST_ACTIVITY_RECORD_NEW_YEAR_TICKET, { data });
        },
        getActivityRecordNewYearTicketUserInfo(data) {
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_NEW_YEAR_TICKET_USER_INFO, { data });
        },
        getActivityRecordNewYearRedEnvelope(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_NEW_YEAR_RED_ENVELOPE, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'updated_at'))
            })));
        },
        getActivityRecordDragonBoatFestival2023(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_DRAGON_BOAT_FESTIVAL_2023, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'updated_at'))
            })));
        },
        getActivityRecordDepositBonus(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_DEPOSIT_BONUS, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'applied_at', 'updated_at'))
            })));
        },
        getActivityRecordUefaBuildingUp(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_UEFA_BUILDING_UP, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'updated_at', 'created_at'))
            })));
        },
        getActivityRecordUefaStars(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_UEFA_STARS, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'updated_at', 'created_at'))
            })));
        },
        getActivityRecordUefaStarsTicket(data) {
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_UEFA_STARS_TICKET, { data });
        },
        postActivityRecordUefaStarsTicket(data) {
            return api.fetch(ADMIN_API.POST_ACTIVITY_RECORD_UEFA_STARS_TICKET, { data });
        },
        getActivityRecordWeeklyBonusDraw(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_WEEKLY_BONUS_DRAW, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'updated_at', 'created_at'))
            })));
        },
        getActivityRecordDailyBonusDraw(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_RECORD_DAILY_BONUS_DRAW, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'updated_at', 'created_at'))
            })));
        },
        getActivityLayoutNewYear2023() {
            return api.fetch(ADMIN_API.GET_ACTIVITY_NEW_YEAR_2023).pipe(map((res) => convertUnixToDate(res, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        updateActivityLayoutNewYear2023(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_NEW_YEAR_2023, { data });
        },
        getActivityLayoutNewYear2024() {
            return api.fetch(ADMIN_API.GET_ACTIVITY_NEW_YEAR_2024).pipe(map((res) => convertUnixToDate(res, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        updateActivityLayoutNewYear2024(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_NEW_YEAR_2024, { data });
        },
        getActivityLayoutNewYear2025() {
            return api.fetch(ADMIN_API.GET_ACTIVITY_NEW_YEAR_2025).pipe(map((res) => convertUnixToDate(res, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        updateActivityLayoutNewYear2025(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_NEW_YEAR_2025, { data });
        },
        getActivityLayoutNewYear2026() {
            return api.fetch(ADMIN_API.GET_ACTIVITY_NEW_YEAR_2026).pipe(map((res) => convertUnixToDate(res, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        updateActivityLayoutNewYear2026(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_NEW_YEAR_2026, { data });
        },
        getActivityLayoutDepositBonus() {
            return api.fetch(ADMIN_API.GET_ACTIVITY_DEPOSIT_BONUS).pipe(map((res) => convertUnixToDate(res, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        updateActivityLayoutDepositBonus(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_DEPOSIT_BONUS, { data });
        },
        getActivityLayoutUefaBuildingUp() {
            return api.fetch(ADMIN_API.GET_ACTIVITY_UEFA_BUILDING_UP).pipe(map((res) => convertUnixToDate(res, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        updateActivityLayoutUefaBuildingUp(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_UEFA_BUILDING_UP, { data });
        },
        getActivityLayoutUefaStars() {
            return api.fetch(ADMIN_API.GET_ACTIVITY_UEFA_STARS).pipe(map((res) => convertUnixToDate(res, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        updateActivityLayoutUefaStars(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_UEFA_STARS, { data });
        },
        getActivityLayoutWeeklyBonusDraw() {
            return api.fetch(ADMIN_API.GET_ACTIVITY_WEEKLY_BONUS_DRAW).pipe(map((res) => convertUnixToDate(res, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        updateActivityLayoutWeeklyBonusDraw(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_WEEKLY_BONUS_DRAW, { data });
        },
        getActivityLayoutDailyBonusDraw() {
            return api.fetch(ADMIN_API.GET_ACTIVITY_DAILY_BONUS_DRAW).pipe(map((res) => convertUnixToDate(res, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        updateActivityLayoutDailyBonusDraw(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_DAILY_BONUS_DRAW, { data });
        },
        getActivityLayoutInviteFriend() {
            return api.fetch(ADMIN_API.GET_ACTIVITY_INVITE_FRIEND).pipe(map((res) => convertUnixToDate(res, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        updateActivityLayoutInviteFriend(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_INVITE_FRIEND, { data });
        },
        getActivityRecordOverview(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_OVERVIEW, { data });
        },
        getActivityRecordAgentOverview(id, payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_OVERVIEW_AGENT, { data, config: { urlParams: { id } } });
        },
        getActivityRecordGoldenOverview(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_OVERVIEW_GOLDEN, { data });
        },
        getActivityApplicationList(payload) {
            const data = payload
                ? {
                    ...payload,
                    start_at: getUnixTime(payload.start_at),
                    end_at: getUnixTime(payload.end_at)
                }
                : null;
            return api.fetch(ADMIN_API.GET_ACTIVITY_APPLICATIONS, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'updated_at'))
            })));
        },
        exportActivityApplicationList(payload) {
            const data = payload
                ? {
                    ...payload,
                    start_at: getUnixTime(payload?.start_at ?? 0),
                    end_at: getUnixTime(payload?.end_at ?? 0)
                }
                : null;
            return api.fetch(ADMIN_API.GET_EXPORT_ACTIVITY_APPLICATIONS, { data });
        },
        updateActivityApplication(data) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_APPLICATION, { data });
        },
        lockActivityApplication(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.POST_ACTIVITY_LOCK_APPLICATIONS, { data });
        },
        getActivityWalletList(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ACTIVITY_WALLET_LIST, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'updated_at', 'expired_at'))
            })));
        },
        getActivityWalletUserInfo(data) {
            return api.fetch(ADMIN_API.GET_ACTIVITY_WALLET_USER_INFO, { data });
        },
        postActivityWalletUserInfoCsv(payload) {
            const data = new FormData();
            data.append('file', payload.file);
            return api.fetch(ADMIN_API.POST_ACTIVITY_WALLET_USER_INFO_CSV, { data });
        },
        postActivityWalletCreate(data) {
            return api.fetch(ADMIN_API.POST_ACTIVITY_WALLET_CREATE, { data });
        },
        postActivityWalletCreateCsv(payload) {
            const data = new FormData();
            data.append('file', payload.file);
            data.append('activity_wallet_title_id', payload.id.toString());
            data.append('multiple', payload.multiple.toString());
            data.append('limit_type', payload.limit_type);
            data.append('expired_at', getUnixTime(payload.expired_at).toString());
            data.append('code', payload.code);
            payload.limit_ids.forEach((id) => data.append('limit_ids[]', id.toString()));
            return api.fetch(ADMIN_API.POST_ACTIVITY_WALLET_CREATE_CSV, { data });
        },
        getActivityWalletCreateProcess() {
            return api.fetch(ADMIN_API.GET_ACTIVITY_WALLET_CREATE_PROCESS).pipe(map((res) => ({
                list: res.list.map((item) => convertUnixToDate(item, 'upload_at')),
                failed_list: res.failed_list.map((item) => convertUnixToDate(item, 'upload_at'))
            })));
        },
        deleteActivityWalletCreateProcess(id) {
            return api.fetch(ADMIN_API.DELETE_ACTIVITY_WALLET_CREATE_PROCESS, { config: { urlParams: { id } } });
        },
        getActivityWalletActivityTitle(data) {
            return api.fetch(ADMIN_API.GET_ACTIVITY_WALLET_ACTIVITY_TITLE, { data });
        },
        updateActivityWalletActivityTitle(data) {
            return api.fetch(ADMIN_API.POST_ACTIVITY_WALLET_ACTIVITY_TITLE, { data });
        },
        updateActivityWalletActivityTitleName(data, id) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_WALLET_ACTIVITY_TITLE, { data, config: { urlParams: { id } } });
        },
        deleteWalletActivityTitleName(id) {
            return api.fetch(ADMIN_API.DELETE_ACTIVITY_WALLET_ACTIVITY_TITLE, { config: { urlParams: { id } } });
        },
        updateActivityWalletActivityTitleOrder(data) {
            return api.fetch(ADMIN_API.POST_ACTIVITY_WALLET_ACTIVITY_TITLE_ORDER, { data });
        },
        getActivityWalletActivityTitleStats(id) {
            return api.fetch(ADMIN_API.GET_ACTIVITY_WALLET_ACTIVITY_TITLE_STATS, { config: { urlParams: { id } } });
        },
        exportActivityWalletValidate(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_EXPORT_ACTIVITY_WALLET_VALIDATE, { data });
        },
        updateActivityWalletBindingDeposits(data, id) {
            return api.fetch(ADMIN_API.PUT_ACTIVITY_WALLET_BINDING_DEPOSITS, { data, config: { urlParams: { id } } });
        },
        revokeActivityWallet(data) {
            return api.fetch(ADMIN_API.POST_ACTIVITY_WALLET_ACTIVITY_REVOKE, { data });
        }
    };
}
//# sourceMappingURL=ActivityService.js.map